import { useAppSelector } from "@/store/hooks";
import {
  selectOnboardingIsSplashVisible,
  useOnboardingDispatch,
} from "@/store/reducers/onboarding";

interface UseOnboardingSplashScreenVisibility {
  isSplashVisible: boolean;
  markSplashAsSeen: () => void;
  resetSplash: () => void;
}

// TODO: persist splash visibility in MMKV (JN-2921)
// Once ready, check `onboarding-splash-seen:{userId}` and only show once per user.
const useOnboardingSplashScreenVisibility =
  (): UseOnboardingSplashScreenVisibility => {
    const isSplashVisible = useAppSelector(selectOnboardingIsSplashVisible);
    const { markSplashAsSeen, resetSplash } = useOnboardingDispatch();

    return {
      isSplashVisible,
      markSplashAsSeen,
      resetSplash,
    };
  };

export default useOnboardingSplashScreenVisibility;
